import React from 'react';
import Helmet from 'react-helmet';
import { useLocation } from '@reach/router';
import FontLoader from './fontLoader';

export const JsonLd = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

const SEO = ({
  description,
  title,
  site,
  image,
  imageAlt,
  pathname,
  type = 'website',
}) => {
  const { pathname: locationPathname } = useLocation();
  const currentPath = pathname || locationPathname || '';

  const defaultDescription = 'Professional knife and tool sharpening services in Northeast Ohio. Sharpening services in Ohio for Westlake, Bay Village, Rocky River, Avon, Avon Lake, North Ridgeville, North Olmstead and more.';
  const metaDescription =
    description || site?.siteMetadata?.description || defaultDescription;
  const truncatedDescription =
    metaDescription?.length > 160
      ? `${metaDescription.substring(0, 157)}...`
      : metaDescription || defaultDescription;

  const siteUrl = site.siteMetadata.siteUrl || '';
  const absoluteUrl = siteUrl ? `${siteUrl.replace(/\/$/, '')}${currentPath || '/'}` : '';

  const ogImage =
    image && image.startsWith('http')
      ? image
      : image
        ? `${siteUrl.replace(/\/$/, '')}${image.startsWith('/') ? image : `/${image}`}`
        : site.siteMetadata.image
          ? `${siteUrl.replace(/\/$/, '')}${site.siteMetadata.image}`
          : null;

  const twitterCard = ogImage ? 'summary_large_image' : 'summary';

  const metaTags = [
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: truncatedDescription,
    },
    {
      property: 'og:type',
      content: type,
    },
    {
      property: 'og:site_name',
      content: site.siteMetadata.title,
    },
    {
      name: 'twitter:card',
      content: twitterCard,
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: truncatedDescription,
    },
  ];

  if (absoluteUrl) {
    metaTags.push(
      { property: 'og:url', content: absoluteUrl },
      { name: 'twitter:url', content: absoluteUrl }
    );
  }

  if (ogImage) {
    metaTags.push(
      { property: 'og:image', content: ogImage },
      { property: 'og:image:width', content: '1200' },
      { property: 'og:image:height', content: '630' }
    );
    metaTags.push({
      name: 'twitter:image',
      content: ogImage,
    });
    if (imageAlt) {
      metaTags.push({
        name: 'twitter:image:alt',
        content: imageAlt,
      });
    }
  }

  if (site.siteMetadata.author) {
    metaTags.push({
      name: 'twitter:creator',
      content: site.siteMetadata.author,
    });
  }

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: 'en',
        }}
        title={title}
        titleTemplate={`%s | ${site.siteMetadata.title}`}
        meta={metaTags}
        defer={false}
      >
        <meta name="description" content={truncatedDescription} />
        <meta
          name="google-site-verification"
          content="uIidjtFiXvT_oQAtSnDkL9EviHJPzRonHAm-AmOco3o"
        />
      </Helmet>
      <FontLoader />
    </>
  );
};

export default SEO;
